import { Link } from "react-router-dom";

import { IconPlus } from "@/components/Icons";
import { Button } from "@/components/kit";

/** Add a sport. A link rather than a form: the editor is where a sport is
 * authored, and it saves as you type, so there is nothing to ask first. */
export function NewSport() {
  return (
    <Button tone="primary">
      <Link
        to="/sports/new"
        style={{
          color: "inherit",
          textDecoration: "none",
          display: "inline-flex",
          alignItems: "center",
          gap: "var(--s2)",
        }}
      >
        <IconPlus size={15} />
        Add a sport
      </Link>
    </Button>
  );
}
